import {
    changeEvent,
    clickEvent,
    dispatchCustomEvent,
    fireInputEvent,
    keyupEvent
} from "../../../../../../../webpack/modules/events";
import {slideDown, slideUp} from "../../../../../../../webpack/modules-optimized/element-visibility";
import {hideOptionErrors} from "../../../../../../../webpack/modules-optimized/product-page";
import {hideOffcanvas} from "../../../../../../../webpack/modules/offcanvas";
import {isDesktop} from "../../../../../../../webpack/modules/devices";
import {addComplement, removeComplement} from "../../../../../../../webpack/modules-optimized/product-list";

let timeoutRecalculateHeight = null;
let oldText = null;
keyupEvent('#product-list-page .product-configuration-customizer[data-option-type="selectable"] textarea[name="customText"], #product-list-page .product-configuration-customizer[data-option-type="selectable"] input[name="customText"]', true, function(element) {
    let configurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let optionCustomizer = configurationMain.querySelector('.product-configuration-main input[name="option-customizer"]');
    let optionValue = optionCustomizer.value !== '' ? JSON.parse(optionCustomizer.value) : {};
    let container = element.closest('.product-configuration-customizer');
    let customText = element.value;
    let customImage = container.querySelector('input[name="custom-image"]');
    let customImageFromWeb = container.querySelector('input[name="customImageFromWeb"]');
    let previewElement = configurationMain.querySelector('.open-configuration .preview-option-customizer');
    let onlyTextSVG = configurationMain.querySelector('input[name="onlyTextSVG"]') ? configurationMain.querySelector('input[name="onlyTextSVG"]').value === 'true' : false;
    let priceIncrement = container.querySelector('input[name="customPriceIncrement"]');
    let customTextLength = element.dataset.maxlen ? parseInt(element.dataset.maxlen) : 0;
    let customTextLengthError = element.dataset.maxlenError ? element.dataset.maxlenError : '';
    let errorContainer = container.querySelector('.error');

    if (errorContainer && customTextLength && customText.length > customTextLength) {
        errorContainer.innerText = customTextLengthError;
        slideDown(errorContainer);
        if (optionValue.hasOwnProperty('personalizedText')) delete optionValue['personalizedText'];
        optionCustomizer.value = optionValue;
        container.dataset.completed = 'false';
        dispatchCustomEvent('productListProductConfigurationChanged');
        return;
    } else {
        slideUp(errorContainer);
    }

    dispatchCustomEvent(
        'productCustomTextChanged',
        {
            'option': container,
            'previewElement': previewElement,
            'increment': priceIncrement,
            'customText': element,
            'customImage': customImage,
            'customImageFromWeb': customImageFromWeb
        }
    );

    optionValue['personalizedText'] = customText;

    if (priceIncrement.checked) addComplement(priceIncrement);
    else removeComplement(priceIncrement);

    if (customText === '') container.dataset.completed = 'false';
    else if ((customImage && customImage.value !== '') || (customImageFromWeb && customImageFromWeb.checked) || !customImage) container.dataset.completed = 'true';

    optionCustomizer.value = JSON.stringify(optionValue);
    hideOptionErrors(container);
    dispatchCustomEvent('productListProductConfigurationChanged');

    if (onlyTextSVG && oldText !== customText) {
        if (timeoutRecalculateHeight) clearTimeout(timeoutRecalculateHeight);
        timeoutRecalculateHeight = setTimeout(function() {
            let sizeConfiguration = isDesktop() ? element.closest('.product').querySelector('.product-configuration-size') : document.querySelector('#product-list-page .offcanvas.product-configuration-size');
            if (!sizeConfiguration) return;
            let customWidth = sizeConfiguration.querySelector('.custom-size input[name="custom-width"]');
            if (customWidth && customWidth.value !== '') fireInputEvent(customWidth, true);
        }, 200);
    }

    oldText = customText;
});

changeEvent('#product-list-page .product-configuration-customizer[data-option-type="selectable"] input[name="customPriceIncrement"]', true, function(element) {
    let configurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration-customizer');
    if (!container.querySelector('input[name="customText"], textarea[name="customText"]')) return;
    let customText = container.querySelector('input[name="customText"], textarea[name="customText"]');
    let customImage = container.querySelector('input[name="custom-image"]');
    let customImageFromWeb = container.querySelector('input[name="customImageFromWeb"]');
    let previewElement = configurationMain.querySelector('.open-configuration .preview-customizer');
    let optionCustomizer = configurationMain.querySelector('.product-configuration-main input[name="option-customizer"]');
    let optionValue = optionCustomizer.value !== '' ? JSON.parse(optionCustomizer.value) : {};

    if (!customText) return;

    dispatchCustomEvent(
        'productCustomTextIncrementChanged',
        {
            'option': container,
            'previewElement': previewElement,
            'customText': customText,
            'increment': element
        }
    );

    optionValue['personalizedText'] = element.checked ? '' : '-';

    if (element.checked) addComplement(element);
    else removeComplement(element);

    if (!element.checked && customText.value === '' && ((customImage && customImage.value !== '') || (customImageFromWeb && customImageFromWeb.checked) || !customImage)) {
        container.dataset.completed = 'true';
    } else {
        container.dataset.completed = 'false';
    }

    optionCustomizer.value = JSON.stringify(optionValue);
    dispatchCustomEvent('productListProductConfigurationChanged');
});